import { Phone, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AnimatedSection } from "@/components/AnimatedSection";

const EmergencyContact = () => {
  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-red-950/40 via-dark-section to-red-950/40">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-red-500/20 rounded-full blur-3xl animate-pulse opacity-30" />
      </div>

      <div className="relative z-10 container mx-auto px-4">
        <AnimatedSection animation="scale-in">
          <div className="max-w-3xl mx-auto text-center">
            <div className="backdrop-blur-2xl bg-red-500/10 border-2 border-red-500/40 rounded-3xl p-12 shadow-liquid-2xl">
              <AlertTriangle className="w-20 h-20 text-red-400 mx-auto mb-6 animate-pulse" />
              
              <h2 className="text-3xl md:text-4xl font-montserrat font-bold text-white mb-4">
                ¿Necesitas Atención Urgente?
              </h2>
              
              <p className="text-lg text-white/80 mb-8 leading-relaxed">
                Si tu local tiene una emergencia eléctrica (corte de luz, olor a quemado, chispas),
                <br className="hidden md:block" />
                <strong className="text-white">llámanos directamente:</strong>
              </p>

              <a href="tel:+56987654321">
                <Button
                  size="lg"
                  className="glass-liquid-medium bg-red-500/90 hover:bg-red-500 text-white text-2xl px-12 py-8 h-auto shadow-liquid-xl hover:shadow-liquid-2xl hover:scale-105 transition-all duration-300"
                >
                  <Phone className="mr-3 h-8 w-8" />
                  +56 9 8765 4321
                </Button>
              </a>

              <p className="text-white/70 text-sm mt-6">
                Atención de emergencias 24/7
              </p>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default EmergencyContact;
